function Loader(){

return(

<div className="fixed inset-0 bg-black flex items-center justify-center">

<div className="border-4 border-white border-t-transparent rounded-full w-12 h-12 animate-spin"/>

</div>

)

}

export default Loader